import React, { FC } from 'react'
import { sanitizeHTML } from '../../../utils/common-utils'
import { getValueListBgColor, getValueListContrastColor } from '../../../utils/background-util'
import { CommitmentContentProps } from '../../Tabs/src/Tabs.types'

export const CommitmentContent: FC<CommitmentContentProps> = ({
  tab,
  testId,
  index,
  mobileButtonRefs,
  buttonsRef,
  handleButtonKeydown,
}) => {
  return (
    <>
      <div
        className={`TabContent Content Grid u-Desktop u-sm-hidden u-md-hidden u-flexJustifyCenter`}>
        {tab.content!.imageSrc && (
          <div
            className={`ImageBox u-size1of2 ${tab.location === 'right' ? ' u-flexOrderLast' : ''}`}>
            <img
              className={`CommitmentsImage`}
              src={tab.content!.imageSrc}
              alt={tab.content!.imageAlt}
              data-testid={testId ? `${testId}-${index}-image` : null}
            />
          </div>
        )}
        <div
          className={`CommitmentsBody Content u-paddingVert9gu u-paddingHoriz8gu ${
            tab.content!.imageSrc ? 'u-size1of2' : ''
          } ${tab.bgcolor && getValueListBgColor(tab.bgcolor)} ${
            tab.bgcolor && getValueListContrastColor(tab.bgcolor)
          }`}
          data-testid={testId ? `${testId}-${index}-content` : null}>
          {tab.content!.heading && tab.content!.heading.length > 0 && (
            <h3
              className='u-textColorNeutral u-textBold'
              data-testid={testId ? `${testId}-${index}-heading` : null}
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(tab.content!.heading ?? '') }}></h3>
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(tab.content!.body ?? ''),
            }}
            data-testid={testId ? `${testId}-${index}-body` : null}
          />

          {tab.content!.linkText && tab.content!.linkText?.length > 0 && (
            <div className='u-paddingTop4gu'>
              <a
                className={`Commitments-button-${index} Button Button--primary`}
                role='button'
                href={tab.content!.link}
                data-analytics={tab.analytics}
                data-testid={testId ? `${testId}-${index}-link` : null}
                onKeyDown={event => {
                  handleButtonKeydown(event, index)
                }}
                ref={el => {
                  buttonsRef.current[index] = el
                }}>
                {tab.content!.linkText}
              </a>
            </div>
          )}
        </div>
      </div>

      <div className={`TabContent Content Grid u-Mobile u-lg-hidden`}>
        <div
          className={`CommitmentsBody Content u-paddingTop8gu u-sm-paddingBottom6gu u-md-paddingBottom6gu u-md-paddingHoriz6gu u-paddingHoriz4gu ${
            tab.bgcolor && getValueListBgColor(tab.bgcolor)
          } ${tab.bgcolor && getValueListContrastColor(tab.bgcolor)}`}>
          {tab.content!.heading && tab.content!.heading.length > 0 && (
            <h2 className='u-textColorNeutral u-textBold'>{tab.content!.heading}</h2>
          )}
          <div
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(tab.content!.body || ''),
            }}></div>
          {tab.content!.linkText && tab.content!.linkText?.length > 0 && (
            <div className='u-paddingTop6gu'>
              <a
                className='Button Button--primary'
                href={tab.content!.link}
                data-analytics={tab.analytics}
                onKeyDown={event => {
                  handleButtonKeydown(event, index)
                }}
                ref={el => {
                  mobileButtonRefs.current[index] = el
                }}>
                {tab.content!.linkText}
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
